import mutations from './accountReportMutation';
import actions from './accountReportAction';
import getters from './accountReportGetter';

const state = {
  listGridData: {},
  changesGridData: {},
};

export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/vuex/accountManagement/accountReport/accountReportStore.js